import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import LangSelector from './LangSelector';

function removeLogoBackground(img) {
  if (!img) return;
  const source = new Image();
  source.onload = function () {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    canvas.width = source.naturalWidth;
    canvas.height = source.naturalHeight;
    ctx.drawImage(source, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    const pts = [[0,0],[canvas.width-1,0],[0,canvas.height-1],[canvas.width-1,canvas.height-1],[Math.floor(canvas.width/2),0]];
    let r=0,g=0,b=0;
    pts.forEach(([x,y]) => { const i=(y*canvas.width+x)*4; r+=data[i];g+=data[i+1];b+=data[i+2]; });
    const bg = { r:Math.round(r/5), g:Math.round(g/5), b:Math.round(b/5) };
    const tol=54, fth=28;
    for (let i=0;i<data.length;i+=4) {
      const d=Math.sqrt(Math.pow(data[i]-bg.r,2)+Math.pow(data[i+1]-bg.g,2)+Math.pow(data[i+2]-bg.b,2));
      if (d<tol) data[i+3]=0;
      else if (d<tol+fth) data[i+3]=Math.min(data[i+3],Math.round(((d-tol)/fth)*255));
    }
    ctx.putImageData(imageData,0,0);
    img.src=canvas.toDataURL('image/png');
  };
  source.src = img.src;
}

export default function Header() {
  const { t } = useLang();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const logoRef = useRef();

  useEffect(() => {
    if (logoRef.current?.complete) removeLogoBackground(logoRef.current);
    else logoRef.current?.addEventListener('load', () => removeLogoBackground(logoRef.current));
  }, []);

  const closeMenu = () => {
    setMenuOpen(false);
    document.body.style.overflow = '';
    document.body.classList.remove('nav-open');
  };

  const toggleMenu = () => {
    const next = !menuOpen;
    setMenuOpen(next);
    document.body.style.overflow = next ? 'hidden' : '';
    document.body.classList.toggle('nav-open', next);
  };

  const isActive = (path) => location.pathname === path ? 'nav-link active' : 'nav-link';

  return (
    <header>
      <Link to="/" className="brand-logo" aria-label="Sttora — Inicio">
        <img ref={logoRef} src="/assets/sttora-logo-web.png" alt="Sttora" />
      </Link>

      <nav className={`main-nav${menuOpen ? ' nav-open' : ''}`} id="mainNav">
        <Link to="/"         className={isActive('/')}         onClick={closeMenu}>{t('nav.home')}</Link>
        <Link to="/nosotros" className={isActive('/nosotros')} onClick={closeMenu}>{t('nav.about')}</Link>
        <span className="nav-link nav-soon" aria-disabled="true">{t('nav.products')}</span>
        <Link to="/contacto" className={isActive('/contacto')} onClick={closeMenu}>{t('nav.contact')}</Link>
        <LangSelector />
      </nav>

      <div className="header-right">
        <button
          className={`nav-toggle${menuOpen ? ' is-open' : ''}`}
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={menuOpen}
          aria-controls="mainNav"
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
